var map = {
	"./binance-profit-calculator/en.js": [
		64,
		133
	],
	"./contact/en.js": [
		63,
		134
	],
	"./contact/es.js": [
		75,
		135
	],
	"./defi-trading-bot/en.js": [
		69,
		45
	],
	"./defi-trading-bot/es.js": [
		76,
		46
	],
	"./devcommunity/en.js": [
		70,
		136
	],
	"./devstrats/broxynet/en.js": [
		77,
		137
	],
	"./devstrats/channelmaestro/en.js": [
		78,
		138
	],
	"./devstrats/expectedmove/en.js": [
		79,
		139
	],
	"./devstrats/gtrendfutures/en.js": [
		80,
		140
	],
	"./devstrats/gtrendspot/en.js": [
		81,
		141
	],
	"./devstrats/machinegun/en.js": [
		82,
		142
	],
	"./devstrats/mfrider/en.js": [
		83,
		143
	],
	"./devstrats/quantaexotrader/en.js": [
		84,
		144
	],
	"./downloads/en.js": [
		67,
		145
	],
	"./downloads/es.js": [
		85,
		146
	],
	"./exchanges/en.js": [
		65,
		147
	],
	"./exchanges/es.js": [
		86,
		148
	],
	"./features/en.js": [
		59,
		38
	],
	"./features/es.js": [
		87,
		39
	],
	"./features_custom-strategies/en.js": [
		66,
		149
	],
	"./features_custom-strategies/es.js": [
		88,
		150
	],
	"./home/en.js": [
		57,
		151
	],
	"./home/es.js": [
		89,
		152
	],
	"./how-gunbot-works/en.js": [
		60,
		7,
		54
	],
	"./how-gunbot-works/es.js": [
		90,
		7,
		55
	],
	"./leaderboard/en.js": [
		71,
		153
	],
	"./leaderboard/es.js": [
		91,
		154
	],
	"./live-demo/en.js": [
		62,
		58
	],
	"./live-demo/es.js": [
		92,
		59
	],
	"./performance/en.js": [
		93,
		155
	],
	"./performance/es.js": [
		94,
		156
	],
	"./performance_pair-pairformance/en.js": [
		95,
		157
	],
	"./performance_pair-pairformance/es.js": [
		96,
		158
	],
	"./plans/en.js": [
		52,
		159
	],
	"./plans/es.js": [
		97,
		160
	],
	"./plans_upgrade/en.js": [
		46,
		161
	],
	"./plans_upgrade/es.js": [
		98,
		162
	],
	"./resellers/en.js": [
		68,
		163
	],
	"./resellers/es.js": [
		99,
		164
	],
	"./topics/en.js": [
		72,
		165
	],
	"./use-cases/en.js": [
		61,
		166
	],
	"./use-cases/es.js": [
		100,
		167
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 45;
module.exports = webpackAsyncContext;